// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".module-wrapper {\n  display: inline-flex;\n  flex-wrap: auto;\n}", "",{"version":3,"sources":["webpack://./src/app/components/mesc/mesc.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,eAAA;AACJ","sourcesContent":[".module-wrapper {\n    display: inline-flex;\n    flex-wrap: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
